import { render } from "./TooltipWrapper.vue?vue&type=template&id=c4296064&scoped=true"
import script from "./TooltipWrapper.vue?vue&type=script&lang=js"
export * from "./TooltipWrapper.vue?vue&type=script&lang=js"

import "./TooltipWrapper.vue?vue&type=style&index=0&id=c4296064&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4296064"]])

export default __exports__